import React from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import Required from "./Required";
import { handleSelectChange } from "../../../utils/Utils";
import { get } from "react-hook-form";

const MySelect = ({
  title,
  multi,
  max,
  name,
  placeholder,
  register,
  watch,
  errors,
  setValue,
  trigger,
  options,
  required,
  isClear,
  showTitle,
  disabled
}) => {
  const error = get(errors, name);

  return (
    <div className="form-group" style={{ marginTop: "10px" }}>
      <Label className="from-label" htmlFor={name}>
        {title?.length > 0 && (
          <>
            {title}
            {required && <Required />}
          </>
        )}
      </Label>

      <div className="form-control-wrap">
        <Select
        isDisabled={disabled}
          isClearable={isClear}
          isMulti={multi}
          placeholder={placeholder}
          id={name}
          options={options}
          value={watch(name)}
          onChange={(e) =>
            handleSelectChange(e, name, setValue, trigger, multi, max)
          }
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              borderColor: errors?.[name] ? "red" : "grey",
            }),
          }}
        />

        <input
          type="hidden"
          {...register(name, {
            required: {
              value: required,
              message: `Please select ${title || "this field"}`,
            },
          })}
        />

        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MySelect;
